import { render, staticRenderFns } from "./SummaryButton.vue?vue&type=template&id=00063398&"
import script from "./SummaryButton.vue?vue&type=script&lang=js&"
export * from "./SummaryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports